module.exports = __webpack_public_path__ + "static/media/sad.b3381379.svg";